
import React from "react";
import "./TimeLine.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
    faUser
} from '@fortawesome/free-solid-svg-icons';

const Timeline = () => (
    <div className="container mt-6">
        <div className="row">
            <div className="col-lg-6">
                <div className="card">
                    <div className="card-header">
                        <h3 className="h5">Dots Timeline</h3>
                    </div>
                    <div className="card-block">
                        <div className="timeline-container">
                            <div className="timeline-line">
                                {/* Item 1 */}
                                <div className="timeline-item">
                                    <div className="timeline-icon bg-primary"></div>
                                    <div className="timeline-content">
                                        <h6 className="mb-10">ALL HANDS MEETING</h6>
                                        <p className="timeline-item-description">Lorem ipsum dolor sic amet, today at 12:00 PM</p>
                                        <p className="timeline-item-time text-primary">12:00 PM</p>
                                    </div>
                                </div>
                                {/* Item 2 */}
                                <div className="timeline-item">
                                    <div className="timeline-icon bg-secondary"></div>
                                    <div className="timeline-content">
                                        <h6 className="mb-10">Another meeting today</h6>
                                        <p className="timeline-item-description">At 12:00 PM</p>
                                        <p className="timeline-item-time text-secondary">12:00 PM</p>
                                    </div>
                                </div>
                                {/* Item 3 */}
                                <div className="timeline-item">
                                    <div className="timeline-icon bg-info"></div>
                                    <div className="timeline-content">
                                        <h6 className="mb-10">Yet another one</h6>
                                        <p className="timeline-item-description">At 15:00 PM</p>
                                        <p className="timeline-item-time text-info">15:00 PM</p>
                                    </div>
                                </div>
                                {/* Item 4 */}
                                <div className="timeline-item">
                                    <div className="timeline-icon bg-success"></div>
                                    <div className="timeline-content">
                                        <h6 className="mb-10">BUILD THE PRODUCTION RELEASE</h6>
                                        <p className="timeline-item-description">
                                            Lorem ipsum dolor sit amet, consectetur eiusmod tempor incididunt ut labore et dolore magna elit enim at minim veniam quis
                                            nostrud.
                                        </p>
                                    </div>
                                </div>
                                {/* Item 5 */}
                                <div className="timeline-item">
                                    <div className="timeline-icon bg-warning"></div>
                                    <div className="timeline-content">
                                        <h6 className="mb-10">SOMETHING NOT IMPORTANT</h6>
                                        <p className="timeline-item-description">
                                            Lorem ipsum dolor sit amet, consectetur elit enim at minim veniam quis nostrud.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-lg-6">
                <div className="card">
                    <div className="card-header">
                        <h3 className="h5">Icon Timeline</h3>
                    </div>
                    <div className="card-block">
                        <div className="timeline-container">
                            <div className="timeline-line">
                                {/* Item 1 */}
                                <div className="timeline-item">
                                    <div className="timeline-badge bg-primary">
                                        <div className="badge-icon text-white">
                                            <FontAwesomeIcon icon={faUser} className="" />
                                        </div>
                                    </div>
                                    <div className="timeline-content">
                                        <h6 className="">ALL HANDS MEETING</h6>
                                        <p className="timeline-item-description">Lorem ipsum dolor sit amet, today at 12:00 PM</p>
                                        <p className="timeline-item-time text-primary">12:00 PM</p>
                                    </div>
                                </div>
                                {/* Item 2 */}
                                <div className="timeline-item">
                                    <div className="timeline-badge bg-secondary">
                                        <div className="badge-icon text-white">
                                            <FontAwesomeIcon icon={faUser} className="" />
                                        </div>
                                    </div>
                                    <div className="timeline-content">
                                        <h6 className="timeline-item-title">Project Meeting</h6>
                                        <p className="timeline-item-description">At 1:00 PM</p>
                                        <p className="timeline-item-time text-secondary">1:00 PM</p>
                                    </div>
                                </div>
                                {/* Item 3 */}
                                <div className="timeline-item">
                                    <div className="timeline-badge bg-info">
                                        <div className="badge-icon text-white">
                                            <FontAwesomeIcon icon={faUser} className="" />
                                        </div>
                                    </div>
                                    <div className="timeline-content">
                                        <h6 className="timeline-item-title">Critical Issue</h6>
                                        <p className="timeline-item-description">Needs immediate attention.</p>
                                        <p className="timeline-item-time text-info">2:30 PM</p>
                                    </div>
                                </div>
                                {/* Item 4 */}
                                <div className="timeline-item">
                                    <div className="timeline-badge bg-success">
                                        <div className="badge-icon text-white">
                                            <FontAwesomeIcon icon={faUser} className="" />
                                        </div>
                                    </div>
                                    <div className="timeline-content">
                                        <h6 className="timeline-item-title">Brainstorming Session</h6>
                                        <p className="timeline-item-description">Discuss new ideas and solutions.</p>
                                        <p className="timeline-item-time text-success">4:00 PM</p>
                                    </div>
                                </div>
                                {/* Item 5 */}
                                <div className="timeline-item">
                                    <div className="timeline-badge bg-warning">
                                        <div className="badge-icon text-white">
                                            <FontAwesomeIcon icon={faUser} className="" />
                                        </div>
                                    </div>
                                    <div className="timeline-content">
                                        <h6 className="">ALL HANDS MEETING</h6>
                                        <p className="timeline-item-description">Lorem ipsum dolor sit amet, today at 12:00 PM</p>
                                        <p className="timeline-item-time text-warning">12:00 PM</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-lg-6">
                <div className="card">
                    <div className="card-header">
                        <h3 className="h5">Image Timeline</h3>
                    </div>
                    <div className="card-block">
                        <div className="timeline-container">
                            <div className="timeline-line">
                                {/* Item 1 */}
                                <div className="timeline-item">
                                <div className="timeline-badge">
                                    <img className="timeline-image" src="./profile.jpg" alt="Profile" />
                                </div>
                                <div className="timeline-content">
                                    <h6 className="timeline-item-title">ALL HANDS MEETING</h6>
                                    <p className="timeline-item-description">Lorem ipsum dolor sit amet, today at 12:00 PM</p>
                                    <p className="timeline-item-time text-muted">12:00 PM</p>
                                </div>
                                </div>

                                {/* Item 2 */}
                                <div className="timeline-item">
                                <div className="timeline-badge">
                                    <img className="timeline-image" src="./profile.jpg" alt="Profile" />
                                </div>
                                <div className="timeline-content">
                                    <h6 className="timeline-item-title">Project Meeting</h6>
                                    <p className="timeline-item-description">At 1:00 PM</p>
                                    <p className="timeline-item-time text-muted">1:00 PM</p>
                                </div>
                                </div>

                                {/* Item 3 */}
                                <div className="timeline-item">
                                <div className="timeline-badge">
                                    <img className="timeline-image" src="./profile.jpg" alt="Profile" />
                                </div>
                                <div className="timeline-content">
                                    <h6 className="timeline-item-title">Critical Issue</h6>
                                    <p className="timeline-item-description">Needs immediate attention.</p>
                                    <p className="timeline-item-time text-muted">2:30 PM</p>
                                </div>
                                </div>

                                {/* Item 4 */}
                                <div className="timeline-item">
                                <div className="timeline-badge">
                                    <img className="timeline-image" src="./profile.jpg" alt="Profile" />
                                </div>
                                <div className="timeline-content">
                                    <h6 className="timeline-item-title">Brainstorming Session</h6>
                                    <p className="timeline-item-description">Discuss new ideas and solutions.</p>
                                    <p className="timeline-item-time text-muted">4:00 PM</p>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="card">
            
            
        </div>
    </div>
);

export default Timeline;
